import * as React from "react"
const SvgHeart = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 21.04q-.349 0-.713-.126a1.65 1.65 0 0 1-.637-.4L8.925 18.94a68 68 0 0 1-4.788-4.812Q2.001 11.738 2 8.864q0-2.35 1.575-3.925T7.5 3.364q1.325 0 2.5.563t2 1.537a5.96 5.96 0 0 1 2-1.537 5.7 5.7 0 0 1 2.5-.563q2.35 0 3.925 1.575Q22 6.515 22 8.864q0 2.875-2.125 5.275a60 60 0 0 1-4.825 4.825l-1.7 1.55a1.65 1.65 0 0 1-.637.4q-.363.125-.713.125Zm-.95-13.576q-.725-1.025-1.55-1.562t-2-.538q-1.5 0-2.5 1t-1 2.5q0 1.3.925 2.763t2.213 2.837a38 38 0 0 0 2.65 2.575q1.362 1.2 2.212 1.975a183 183 0 0 1 2.213-1.975q1.362-1.2 2.65-2.575a19 19 0 0 0 2.212-2.837Q20 10.164 20 8.864q0-1.5-1-2.5t-2.5-1q-1.175 0-2 .538-.825.537-1.55 1.562a1.14 1.14 0 0 1-.95.5 1.14 1.14 0 0 1-.95-.5" />
  </svg>
)
export default SvgHeart
